/* eslint-disable no-console */
import axios, { AxiosError } from "axios";
import { IApplicationContextResponse } from "../../utils/types/applicationContextTypes";
import { axiosRequestConfig, BaseMembershipUrl } from "../apiConstants";

const getApplicationContext = async (id: number, jwt: string) => {
  try {
    return await axios.get<IApplicationContextResponse>(
      `${BaseMembershipUrl}/ApplicationContext/${id}`,
      axiosRequestConfig(jwt)
    );
  } catch (err) {
    console.error("error: ", err);
    return (err as AxiosError<IApplicationContextResponse>).response;
  }
};

export default getApplicationContext;
